import { Check, X, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { rupiah, tanggalPanjang } from "@/lib/format";
import { DONATION_TYPES, STATUS_LABEL, STATUS_TONE } from "@/lib/donation";
import { fileUrl } from "@/lib/api";

const Row = ({ label, value, testId }) => (
  <div className="flex justify-between gap-4 text-sm border-b border-emerald-900/10 py-2">
    <span className="text-slate-500">{label}</span>
    <span className="font-medium text-right" data-testid={testId}>{value}</span>
  </div>
);

export const DonationDetail = ({ donation: d, onClose, onConfirm, onReject, busy }) => {
  if (!d) return null;
  const token = localStorage.getItem("access_token");
  const proofUrl = d.proof_path ? `${fileUrl(d.proof_path)}${token ? `?auth=${token}` : ""}` : null;
  return (
    <Dialog open={!!d} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="donation-detail-dialog">
        <DialogHeader><DialogTitle>Detail Donasi</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-6">
          <div>
            <Row label="Status" value={<Badge className={STATUS_TONE[d.status]}>{STATUS_LABEL[d.status]}</Badge>} />
            <Row label="Nama" value={`${d.real_name}${d.anonymous ? " (tampil: Hamba Allah)" : ""}`} testId="detail-name" />
            <Row label="No. WhatsApp" value={d.phone || "-"} />
            <Row label="Jenis Donasi" value={DONATION_TYPES[d.type]} testId="detail-type" />
            <Row label="Nominal" value={<span className="text-emerald-800 font-bold">{rupiah(d.amount)}</span>} testId="detail-amount" />
            <Row label="Metode" value={d.method === "transfer" ? "Transfer Bank" : "QRIS"} />
            <Row label="Tanggal" value={tanggalPanjang(d.date)} />
            {d.note && <Row label="Catatan" value={d.note} />}
          </div>
          <div>
            <p className="text-sm text-slate-500 mb-2">Bukti Transfer</p>
            {proofUrl ? (
              <a href={proofUrl} target="_blank" rel="noreferrer" data-testid="detail-proof-link">
                <img src={proofUrl} alt="Bukti transfer" className="rounded-2xl border border-emerald-900/10 w-full max-h-72 object-contain bg-slate-50" data-testid="detail-proof-image" />
              </a>
            ) : (
              <p className="text-sm text-slate-400">Tidak ada bukti.</p>
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          {d.status !== "ditolak" && (
            <Button variant="outline" className="rounded-full text-red-700 border-red-200 hover:bg-red-50" disabled={busy} onClick={() => onReject(d)} data-testid="detail-reject-btn">
              <X size={16} className="mr-1" /> Tolak
            </Button>
          )}
          {d.status !== "dikonfirmasi" && (
            <Button className="rounded-full emerald-bg hover:bg-[#145c48]" disabled={busy} onClick={() => onConfirm(d)} data-testid="detail-confirm-btn">
              {busy ? <Loader2 className="animate-spin" size={16} /> : <><Check size={16} className="mr-1" /> Konfirmasi</>}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
